import { createContext, useContext } from 'react';

import type { CompareViewMode } from './compare-grid.types';

/**
 * Controls for the Table/Compare view switch, surfaced inline in the preview
 * section header. Mirrors `ViewBeforeCtx` so the nested preview tables read the
 * mode from context instead of the page prop-drilling it through every variant.
 */
export interface CompareViewControls {
  mode: CompareViewMode;
  onModeChange: (mode: CompareViewMode) => void;
}

/** Wrap a preview subtree in `<CompareViewCtx.Provider>` to offer the Table/Compare switch, with state owned by the page. */
export const CompareViewCtx = createContext<CompareViewControls | null>(null);

/** Reads the ambient view-mode controls; returns null when no provider is present, in which case callers stay on the table. */
export function useCompareView(): CompareViewControls | null {
  return useContext(CompareViewCtx);
}
